<template>
  <TemplateView>
    <v-container class="d-grid gap-5 gap-md-20">
      <BaseSection
        :title="
          localStorage.translations.pages.sales_project.sections['proektnye-i-klientskie-dannye']
        "
        :expansion="$vuetify.breakpoint.smAndDown"
        :error="errorForm.designAndCustomer"
      >
        <template v-slot:titleRight>
          <BaseTooltip
            v-if="
              userData.employee &&
              (userData.employee.id === workClientProjectShow.project_manager_employee_id ||
                projectsChat) &&
              workClientProjectShow.status === 'in_progress' &&
              !edit
            "
            :tooltip="
              projectsChat
                ? localStorage.translations.pages.chat.all.project_chat
                : localStorage.translations.pages.chat.all.create_project
            "
          >
            <BaseButton
              color="primary"
              @click="onClickProjectChat"
              depressed
              class="rounded-lg"
              default_icon="chat-main"
              minimalize
              icon_only
            />
          </BaseTooltip>
        </template>
        <ProjectDesignAndCustomer :edit="edit" ref="designAndCustomer" />
      </BaseSection>
      <BaseSection
        v-if="companiesConfig.schemes !== '0' || companiesConfig.documents !== '0'"
        :title="localStorage.translations.pages.sales_project.sections['chertezhi-i-dokumenty']"
        :expansion="$vuetify.breakpoint.smAndDown"
        :error="errorForm.schemesAndDocuments"
      >
        <ProjectSchemesAndDocuments :edit="edit" ref="schemesAndDocuments" />
      </BaseSection>
      <BaseSection
        v-if="companiesConfig.work_type_prices !== '0' || companiesConfig.extra_work_price !== '0'"
        :title="localStorage.translations.pages.sales_project.sections['materialy-i-tseny']"
        :expansion="$vuetify.breakpoint.smAndDown"
        :error="errorForm.materialsAndPrices"
      >
        <ProjectMaterialsAndPrices
          :edit="edit"
          ref="materialsAndPrices"
          :projectRequiredData="projectRequiredData"
        />
      </BaseSection>
      <BaseSection
        :title="localStorage.translations.pages.sales_project.sections['planiruemye-resursy']"
        :expansion="$vuetify.breakpoint.smAndDown"
        :error="errorForm.plannedResources"
      >
        <ProjectPlannedResources
          :edit="edit"
          ref="plannedResources"
          :projectRequiredData="projectRequiredData"
        />
        <BaseCard
          :title="
            localStorage.translations.pages.sales_project['planned_resources-labels'][
              'status-proekta'
            ]
          "
          class="mt-8"
        >
          <v-card
            v-if="
              !edit &&
              workClientProjectShow.status !== 'canceled' &&
              workClientProjectShow.status !== 'done' &&
              workClientProjectShow.status !== 'intro'
            "
            class="pa-2 justify-self-start"
            :color="statusColor.bg"
            flat
            :dark="statusColor.dark"
          >
            {{ statusText() }}
          </v-card>
          <BaseInput
            v-else
            v-model="status"
            :items="items"
            type="select"
            item-value="data"
            :item-text="(item) => item.text"
            append-icon="fas fa-angle-down"
            class="justify-self-start"
          />
          <BaseButton
            v-if="
              (workClientProjectShow.status == 'canceled' ||
                workClientProjectShow.status == 'intro' ||
                workClientProjectShow.status == 'done') &&
              $userCheckAccess({
                abilities: $route.name === 'SalesProjectShow' ? 'edit_sales' : 'edit_projects',
              })
            "
            @click="onProjectDoneAndCanceledUpdateStatus"
            :text="localStorage.translations.pages.common['buttons']['sohranit']"
            default_icon="button-save"
            :disabled="status === workClientProjectShow.status"
          />
        </BaseCard>
      </BaseSection>
    </v-container>
    <div class="fixedBtnTop" :class="fab ? 'fab' : ''">
      <template v-if="!edit">
        <BaseTooltip
          :tooltip="localStorage.translations.pages.sales_project.price_offer_terms.title"
          v-if="
            workClientProjectShow.status !== 'creating' &&
            workClientProjectShow.status !== 'canceled' &&
            workClientProjectShow.status !== 'intro' &&
            workClientProjectShow.status !== 'done' &&
            $userCheckAccess({ abilities: 'view_all_client_project' })
          "
        >
          <BaseButton
            v-scroll="onScroll"
            @click="
              $router.push({
                name: SalesPage ? 'SalesProjectProposed' : 'ProjectsProjectProposed',
                params: { id: $route.params.id },
              })
            "
            round
            :size="$vuetify.breakpoint.smAndDown ? 45 : 60"
            :padding="$vuetify.breakpoint.smAndDown ? 10 : null"
            icon_only
          >
            <template v-slot:icon>
              <svg
                width="27"
                height="27"
                viewBox="0 0 27 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.5941 17.0786L10.1475 23.3606C10.7865 23.3606 11.0633 23.0861 11.3951 22.7565L14.391 19.8934L20.5988 24.4395C21.7373 25.074 22.5394 24.7399 22.8465 23.3921L26.9213 4.29861L26.9224 4.29748C27.2835 2.61448 26.3138 1.95636 25.2045 2.36923L1.25325 11.5391C-0.381377 12.1736 -0.356627 13.0849 0.975374 13.4977L7.09875 15.4024L21.3221 6.50248C21.9915 6.05923 22.6001 6.30448 22.0995 6.74773L10.5941 17.0786Z"
                  fill="white"
                />
              </svg>
            </template>
          </BaseButton>
        </BaseTooltip>
      </template>
    </div>
    <div class="fixedBtn">
      <BaseTooltip
        v-if="edit"
        :tooltip="localStorage.translations.pages.common['buttons']['sohranit']"
      >
        <BaseButton
          @click="onSaveChange"
          round
          :size="$vuetify.breakpoint.smAndDown ? 45 : 60"
          :padding="$vuetify.breakpoint.smAndDown ? 10 : null"
          icon_only
          default_icon="button-save"
        />
      </BaseTooltip>
      <template v-else>
        <template v-if="workClientProjectShow.status !== 'creating' && !SalesPage">
          <BaseTooltip :tooltip="localStorage.translations.pages.projects.pages['statistics']">
            <BaseButton
              @click="$router.push({ name: 'timeControlShow', params: { id: $route.params.id } })"
              round
              :size="$vuetify.breakpoint.smAndDown ? 45 : 60"
              :padding="$vuetify.breakpoint.smAndDown ? 10 : null"
              icon_only
              default_icon="pages-projects-statistic"
              icon-color="white"
            />
          </BaseTooltip>
          <BaseTooltip :tooltip="localStorage.translations.pages.projects.pages['project_reports']">
            <BaseButton
              @click="
                $router.push({ name: 'timeControlShowReports', params: { id: $route.params.id } })
              "
              round
              :size="$vuetify.breakpoint.smAndDown ? 45 : 60"
              :padding="$vuetify.breakpoint.smAndDown ? 10 : null"
              icon_only
            >
              <template v-slot:icon>
                <svg
                  width="18"
                  height="24"
                  viewBox="0 0 18 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3 0C2.20435 0 1.44129 0.31607 0.87868 0.87868C0.31607 1.44129 0 2.20435 0 3V21C0 21.7956 0.31607 22.5587 0.87868 23.1213C1.44129 23.6839 2.20435 24 3 24H15C15.7957 24 16.5587 23.6839 17.1213 23.1213C17.6839 22.5587 18 21.7956 18 21V8.121C17.9998 7.32542 17.6836 6.56248 17.121 6L12 0.879C11.4375 0.316352 10.6746 0.000169912 9.879 0H3ZM6 15C6 14.6022 5.84196 14.2206 5.56066 13.9393C5.27936 13.658 4.89783 13.5 4.5 13.5C4.10218 13.5 3.72064 13.658 3.43934 13.9393C3.15804 14.2206 3 14.6022 3 15V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21C4.89783 21 5.27936 20.842 5.56066 20.5607C5.84196 20.2794 6 19.8978 6 19.5V15ZM9 10.5C9.39783 10.5 9.77936 10.658 10.0607 10.9393C10.342 11.2206 10.5 11.6022 10.5 12V19.5C10.5 19.8978 10.342 20.2794 10.0607 20.5607C9.77936 20.842 9.39783 21 9 21C8.60218 21 8.22064 20.842 7.93934 20.5607C7.65804 20.2794 7.5 19.8978 7.5 19.5V12C7.5 11.6022 7.65804 11.2206 7.93934 10.9393C8.22064 10.658 8.60218 10.5 9 10.5ZM15 9C15 8.60218 14.842 8.22064 14.5607 7.93934C14.2794 7.65804 13.8978 7.5 13.5 7.5C13.1022 7.5 12.7206 7.65804 12.4393 7.93934C12.158 8.22064 12 8.60218 12 9V19.5C12 19.8978 12.158 20.2794 12.4393 20.5607C12.7206 20.842 13.1022 21 13.5 21C13.8978 21 14.2794 20.842 14.5607 20.5607C14.842 20.2794 15 19.8978 15 19.5V9Z"
                    fill="#F2F2F2"
                  />
                </svg>
              </template>
            </BaseButton>
          </BaseTooltip>
        </template>
        <BaseTooltip
          :tooltip="localStorage.translations.pages.common['buttons']['redaktirovat']"
          v-if="
            workClientProjectShow.status !== 'canceled' &&
            workClientProjectShow.status !== 'intro' &&
            workClientProjectShow.status !== 'done' &&
            $userCheckAccess({ abilities: SalesPage ? 'edit_sales' : 'edit_projects' })
          "
        >
          <BaseButton
            @click="onEdit"
            round
            :size="$vuetify.breakpoint.smAndDown ? 45 : 60"
            :padding="$vuetify.breakpoint.smAndDown ? 10 : null"
            icon_only
            default_icon="button-edit"
            class="mt-4"
          />
        </BaseTooltip>
      </template>
    </div>
  </TemplateView>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'

import ProjectDesignAndCustomer from 'components/project/ProjectDesignAndCustomer'
import ProjectSchemesAndDocuments from 'components/project/schemesAndDocuments/ProjectSchemesAndDocuments'
import ProjectMaterialsAndPrices from 'components/project/materialsAndPrices/ProjectMaterialsAndPrices'
import ProjectPlannedResources from 'components/project/plannedResources/ProjectPlannedResources'
import BaseInput from 'components/base/BaseInput'
import vuetify from '@/plugins/vuetify'

export default {
  name: 'salesProjectShow',
  components: {
    BaseInput,
    ProjectPlannedResources,
    ProjectMaterialsAndPrices,
    ProjectSchemesAndDocuments,
    ProjectDesignAndCustomer,
  },
  refs: ['designAndCustomer', 'schemesAndDocuments', 'materialsAndPrices', 'plannedResources'],
  data: () => ({
    status: null,
    statusSave: null,
    panel: [],
    accordion: {
      designAndCustomer: false,
      schemesAndDocuments: false,
      materialsAndPrices: false,
      plannedResources: false,
    },
    loadingData: false,
    fab: false,
  }),
  watch: {
    '$route.name'() {
      this.onActualData(true)
    },
    workClientProjectShow() {
      this.onActualData(true)
    },
    checkLoadingStatus() {
      if (this.checkLoadingStatus) {
        this.setLoadingAnimationFullPage(true)
      } else {
        this.setLoadingAnimationFullPage(false)
      }
    },
    status() {
      this.onNavigationGuardianCheck({
        data: { status: this.status },
      })
    },
  },
  created() {},
  mounted() {
    this.onActualData(true)
  },
  computed: {
    ...mapState(['configData']),
    ...mapGetters(['companiesConfig']),
    ...mapGetters('workClientProject', ['workClientProjectShow']),
    ...mapGetters('user', ['userData', 'userType']),
    ...mapState('chat', ['chatsList']),
    projectsChat() {
      return this.chatsList.find(
        (i) =>
          i.metadata &&
          i.metadata.userGroup.type === 'project' &&
          Number(i.metadata.userGroup.id) === Number(this.workClientProjectShow.id),
      )
    },
    errorForm() {
      if (this.$refs.designAndCustomer)
        return {
          designAndCustomer:
            this.$vuetify.breakpoint.smAndDown &&
            this.$refs.designAndCustomer &&
            !this.$refs.designAndCustomer.valid,
          schemesAndDocuments:
            this.$vuetify.breakpoint.smAndDown &&
            this.$refs.schemesAndDocuments &&
            !(
              this.$refs.schemesAndDocuments.validSchemes &&
              this.$refs.schemesAndDocuments.validDocuments
            ),
          materialsAndPrices:
            this.$vuetify.breakpoint.smAndDown &&
            this.$refs.materialsAndPrices &&
            !this.$refs.materialsAndPrices.valid,
          plannedResources:
            this.$vuetify.breakpoint.smAndDown &&
            this.$refs.plannedResources &&
            !this.$refs.plannedResources.valid,
        }
      else return {}
    },
    checkLoadingStatus() {
      const checkArray = [
        this.loadingData,
        this.$refs.designAndCustomer && this.$refs.designAndCustomer.loadingData,
        this.$refs.schemesAndDocuments && this.$refs.schemesAndDocuments.loadingData,
        this.$refs.materialsAndPrices && this.$refs.materialsAndPrices.loadingData,
        this.$refs.plannedResources && this.$refs.plannedResources.loadingData,
      ]
      return checkArray.find((i) => i === true) ? true : false
    },
    checkUserProjectManager() {
      return this.userData && !!this.userData.employee
        ? this.userData.employee && this.userData.employee.id === this.workClientProjectShow.project_manager_employee_id
        : false
    },
    SalesPage() {
      return this.$route.name === 'SalesProjectShow' || this.$route.name === 'SalesArchiveShow'
    },
    projectRequiredData() {
      let obj = {
        name: this.$refs.designAndCustomer && this.$refs.designAndCustomer.name,
        work_client_id: this.$refs.designAndCustomer && this.$refs.designAndCustomer.work_client_id,
      }
      return obj
    },
    edit() {
      return (
        this.$route.name == 'SalesProjectShowEdit' || this.$route.name == 'ProjectsProjectShowEdit'
      )
    },
    statusColor() {
      switch (this.workClientProjectShow.status) {
        case 'creating':
          return {
            bg: '#F2C94C',
            text: '',
          }
        /*case 'intro':
          return {
            bg: '#F2C94C',
          }*/
        case 'bidding':
          return {
            bg: '#F2994A',
          }
        case 'canceled':
          return {
            bg: '#EB5757',
            dark: true,
          }
        case 'pending':
          return {
            bg: '#333333',
            dark: true,
          }
        case 'in_progress':
          return {
            bg: '#2D9CDB',
            dark: true,
          }
        case 'done':
          return {
            bg: '#27AE60',
            dark: true,
          }
        default:
          return {
            bg: '',
            text: '',
          }
      }
    },
    items() {
      let result = []
      if (
        this.workClientProjectShow.status == 'bidding' ||
        this.workClientProjectShow.status == 'pending'
      ) {
        result = [
          /*{
            data: 'intro',
            text: this.localStorage.translations.pages.projects_status.status['beginer'],
          },*/
          {
            data: 'bidding',
            text: this.localStorage.translations.pages.projects_status.status['tsenopredlozhenie'],
          },
          {
            data: 'pending',
            text: this.localStorage.translations.pages.projects_status.status['v-ozhidanii'],
          },
          {
            data: 'canceled',
            text: this.localStorage.translations.pages.projects_status.status['ne-sostoyavshiysya'],
          },
          {
            data: 'in_progress',
            text: this.localStorage.translations.pages.projects_status.status['v-rabote'],
          },
        ]
      } else if (this.workClientProjectShow.status == 'in_progress') {
        result = [
          {
            data: 'in_progress',
            text: this.localStorage.translations.pages.projects_status.status['v-rabote'],
          },
          {
            data: 'done',
            text: this.localStorage.translations.pages.projects_status.status['zavershen'],
          },
        ]
      } else if (
        this.workClientProjectShow.status == 'canceled' ||
        this.workClientProjectShow.status == 'intro'
      ) {
        result = [
          {
            data: 'canceled',
            text: this.localStorage.translations.pages.projects_status.status['ne-sostoyavshiysya'],
          },
          /*{
            data: 'intro',
            text: this.localStorage.translations.pages.projects_status.status['beginer'],
          },*/
          {
            data: 'bidding',
            text: this.localStorage.translations.pages.projects_status.status['tsenopredlozhenie'],
          },
        ]
      } else if (this.workClientProjectShow.status == 'done') {
        result = [
          {
            data: 'done',
            text: this.localStorage.translations.pages.projects_status.status['zavershen'],
          },
          {
            data: 'in_progress',
            text: this.localStorage.translations.pages.projects_status.status['v-rabote'],
          },
        ]
      }
      return result
    },
  },
  // mounted() {
  //     this.dynamicAccordion()
  // },
  // watch: {
  //     '$vuetify.breakpoint.width'() {
  //         this.dynamicAccordion()
  //     },
  // },
  methods: {
    onScroll(e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset || e.target.scrollTop || 0
      this.fab = top > 20
    },
    vuetify() {
      return vuetify
    },
    ...mapActions('workClientProject', [
      'onWorkClientProjectUpdate_status',
      'onWorkClientProjectShow',
      'onWorkClientProjectUpdate',
    ]),
    ...mapActions('navigationGuardian', [
      'onNavigationGuardianCheck',
      'offNavigationGuardianCheck',
    ]),
    ...mapMutations('workClientProject', ['setWorkClientProjectShow']),
    ...mapMutations(['setLoadingAnimationFullPage']),
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    ...mapActions('chat', ['CREATE_chatGroup']),
    onActualData(check) {
      if (this.workClientProjectShow) {
        this.status = this.workClientProjectShow.status
        this.statusSave = this.workClientProjectShow.status
        if (check) {
          this.onNavigationGuardianCheck({
            data: { status: this.status },
            overwrite: true,
          })
        }
      }
      return true
    },
    changeAccordion(name) {
      if (this.accordion[name]) {
        this.accordion[name] = false
      } else {
        this.accordion[name] = true
      }
    },
    onEdit() {
      this.$router
        .push({
          name:
            this.$route.name === 'SalesProjectShow'
              ? 'SalesProjectShowEdit'
              : 'ProjectsProjectShowEdit',
          params: { id: this.$route.params.id },
        })
        .then(() => this.onActualData(true))
    },
    async offEdit() {
      await this.onActualData(true)
      this.$router.push({
        name:
          this.$route.name === 'SalesProjectShowEdit'
            ? 'SalesProjectShow'
            : this.$route.name === 'ProjectsProjectShowEdit'
            ? 'ProjectsProjectShow'
            : '',
        params: { id: this.$route.params.id },
      })
    },
    statusText() {
      return this.workClientProjectShow.status == 'creating'
        ? this.localStorage.translations.pages.projects_status.status['predvaritelnyy']
        : //: this.workClientProjectShow.status == 'intro'
        //? this.localStorage.translations.pages.projects_status.status['beginer']
        this.workClientProjectShow.status == 'bidding'
        ? this.localStorage.translations.pages.projects_status.status['tsenopredlozhenie']
        : this.workClientProjectShow.status == 'canceled'
        ? this.localStorage.translations.pages.projects_status.status['ne-sostoyavshiysya']
        : this.workClientProjectShow.status == 'pending'
        ? this.localStorage.translations.pages.projects_status.status['v-ozhidanii']
        : this.workClientProjectShow.status == 'in_progress'
        ? this.localStorage.translations.pages.projects_status.status['v-rabote']
        : this.workClientProjectShow.status == 'done'
        ? this.localStorage.translations.pages.projects_status.status['zavershen']
        : null
    },
    onProjectDoneAndCanceledUpdateStatus() {
      return new Promise(async (resolve, reject) => {
        if (this.status !== this.statusSave) {
          let data = {
            id: this.workClientProjectShow.id,
            name:
              (this.projectRequiredData && this.projectRequiredData.name) ||
              this.workClientProjectShow.name,
            status: this.status,
          }
          this.onWorkClientProjectUpdate_status(data).then(async (resp) => {
            await this.onNavigationGuardianCheck({
              data: { status: this.status },
              overwrite: true,
            })
            resolve(resp)
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications[
                    'izmeneniya-uspeshno-sohraneny'
                  ],
                IsError: false,
              },
              { root: true },
            )
            if (this.status !== this.statusSave) {
              if (this.status === 'bidding') {
                this.$router.push({ name: 'Sales' })
              } else if (this.status === 'canceled') {
                this.$router.push({ name: 'SalesArchive' })
              } else if (this.status === 'in_progress' || this.status === 'pending') {
                this.$router.push({ name: 'Projects' })
              } else {
                this.$router.push({ name: 'ProjectsDone' })
              }
            }
          })
        } else resolve(true)
      })
    },
    async onSaveChange() {
      let temp = [this.$refs.designAndCustomer.validate()]
      if (this.companiesConfig.schemes !== '0')
        temp.push(this.$refs.schemesAndDocuments.validateSchemes())
      if (this.companiesConfig.documents !== '0')
        temp.push(this.$refs.schemesAndDocuments.validateDocuments())
      if (this.companiesConfig.work_type_prices !== '0')
        temp.push(this.$refs.materialsAndPrices.validate())
      if (this.companiesConfig.extra_work_price !== '0')
        temp.push(this.$refs.plannedResources.validate())
      
      if (this.$refs.schemesAndDocuments) await this.$refs.schemesAndDocuments.onEdit()
      Promise.all(temp)
        .then(async (resp) => {
          console.log('========>>>>', this.workClientProjectShow)
          const [designAndCustomerData, plannedResourcesData, materialsAndPricesData] =
            await Promise.all([
              this.$refs.designAndCustomer.onCreateOrUpdate(),
              this.$refs.plannedResources ? this.$refs.plannedResources.onCreateOrUpdate() : true,
              this.$refs.materialsAndPrices ? this.$refs.materialsAndPrices.onUpdateExtraPrice(true) : true,
            ])

          const projectData = {
            ...designAndCustomerData,
            ...plannedResourcesData,
            ...materialsAndPricesData,
            images_in_report: this.workClientProjectShow.images_in_report,
          }
          console.log('projectData', projectData)
          let promises = [
            Object.keys(projectData).length > 3 ? this.onWorkClientProjectUpdate(projectData) : false,
            this.$refs.materialsAndPrices ? this.$refs.materialsAndPrices.onCreateOrUpdate() : true,
            this.$refs.schemesAndDocuments ? this.$refs.schemesAndDocuments.onSchemesUpdate() : true,
            this.$refs.schemesAndDocuments ? this.$refs.schemesAndDocuments.onDocumentsUpdate() : true,
            this.onProjectDoneAndCanceledUpdateStatus(),
             //this.onWorkClientProjectUpdate_status(data),
            this.$refs.plannedResources ? this.$refs.plannedResources.onCreateOrUpdate() : true,
          ]
          Promise.all(promises)
            .then(async (resp) => {
              this.$refs.schemesAndDocument && this.$refs.schemesAndDocuments.offEdit()
              await this.offNavigationGuardianCheck()
              if (resp.find((i) => i !== true)) {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message:
                      this.localStorage.translations.pages.common.notifications['izmeneniya-uspeshno-sohraneny'],
                    IsError: false,
                  },
                  { root: true },
                )
              }
              this.offEdit()
            })
            .catch((err) => {
              console.log('err', err)
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message: this.localStorage.translations.pages.common.notifications['oshibka'],
                  IsError: true,
                },

                { root: true },
              )
            })
        })
        .catch((err) => {
          console.log('err', err)
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications[
                  'fill_in_required_fields'
                ],
              IsError: true,
            },

            { root: true },
          )
          return
        })
    },
    onClickProjectChat() {
      console.log('onClickProjectChat')
      if (this.projectsChat) {
        this.$router.push({ name: 'chat', params: { id: this.projectsChat.id } })
      } else {
        if (this.userData.employee.id === this.workClientProjectShow.project_manager_employee_id) {
          let data = {
            usersGroupType: 'project',
            usersGroupId: String(this.workClientProjectShow.id),
          }
          this.CREATE_chatGroup({ data })
        }
      }
    },
  },
  destroyed() {
    this.setWorkClientProjectShow()
  },
}
</script>

<style scoped lang="scss">
.fab {
  top: 70px;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    top: 50px;
  }
}
</style>
